import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'store/auth';
import { getMetaData } from 'store/settingAccount';
import {
  ARR_USER_ROLES,
  SESSION_EXPIRY,
  TEMP_USER_TOKEN,
  USER_TOKEN,
  USER_VIEW_MODE,
} from 'helpers/storage';
import { parseLogoutTime } from 'helpers/session-time';

export default function useIdleLogout() {
  const router = useRouter();
  const dispatch = useDispatch();
  const metaData = useSelector(getMetaData);

  const handleLogout = () => {
    console.log('⏰ Idle timeout reached, logging out...');
    router.push('/home').then(() => {
      dispatch(logout());
      USER_TOKEN.delete();
      USER_VIEW_MODE.delete();
      ARR_USER_ROLES.delete();
      TEMP_USER_TOKEN.delete();
      SESSION_EXPIRY.delete();
    });
  };

  const resetExpiry = () => {
    if (!metaData?.logoutExpiredTime) return;
    const newExpiry = Date.now() + parseLogoutTime(metaData.logoutExpiredTime);
    SESSION_EXPIRY.set(newExpiry);
  };

  const checkExpiry = () => {
    const expiry = parseInt(SESSION_EXPIRY.get());
    if (expiry && Date.now() > expiry) {
      handleLogout();
    } else {
      resetExpiry();
    }
  };

  useEffect(() => {
    if (!metaData?.logoutExpiredTime) return;

    if (!SESSION_EXPIRY.get()) {
      resetExpiry();
    }

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach((e) => window.addEventListener(e, checkExpiry));

    return () => {
      events.forEach((e) => window.removeEventListener(e, checkExpiry));
    };
  }, [metaData?.logoutExpiredTime]);
}
